export const RoleNames = ['BOOTROCK_COMPANY_MASTER', 'BOOTROCK_COMPANY_MANAGER'];
